import { IExaminationDataValue } from "@/models/ExaminationDataValue";

const format = {
  Tinh: { fractional: 1 },
  Texh: { fractional: 1 },
  Rinh: { fractional: 3 },
  Rexh: { fractional: 3 },
  Rsum: { fractional: 3 },
  "%CO2inh": { fractional: 2 },
  "%CO2avg": { fractional: 2 },
  "%CO2exh": { fractional: 2 },
  "%O2inh": { fractional: 1 },
  "Extr.V": { fractional: 2 },
  "Extr.T": { fractional: 1 },
  CO2V: { fractional: 2 },
  "Vent.V": { fractional: 1 },
  "Vent.T": { fractional: 1 },
  D46: { fractional: 1 },
  D48: { fractional: 2 },
  D50: { fractional: 1 },
};

const formatExaminationDataValue = (el: IExaminationDataValue) => {
  const newEl = { ...el };
  Object.entries(format).forEach(([key, value]) => {
    // @ts-ignore
    newEl[key] = Number(newEl[key]).toFixed(value.fractional);
  });
  return newEl;
};

export default formatExaminationDataValue;
